(function(document, window, $) {
    'use strict';

    var Site = window.Site;

    $(document).ready(function($) {
       // Site.run();


        //$('.fixedsticky').fixedsticky();
        $('table.floatthead').floatThead({
            position: 'fixed',
            top:70,
        });

    });


})(document, window, jQuery);